<div class="pipeline-runs-container">
  <section class="pipeline-runs-filters" aria-label="Filtros do histórico de execuções">
    <div class="pipeline-runs-filters__main">
      <div class="pipeline-runs-filters__group">
        <span class="pipeline-runs-filters__legend" id="pipeline-runs-status-legend">Status</span>
        <mat-button-toggle-group
          class="pipeline-runs-segmented"
          [value]="statusFilter()"
          (change)="onStatusFilterChange($event.value)"
          name="pipeline-runs-status"
          aria-labelledby="pipeline-runs-status-legend"
          hideSingleSelectionIndicator>
          @for (option of statusOptions; track option.value) {
            <mat-button-toggle
              [value]="option.value"
              [disabled]="isStatusOptionDisabled(option.value)"
              [attr.aria-checked]="statusFilter() === option.value">
              @if (option.dot) {
                <span
                  class="pipeline-runs-segmented__dot"
                  [class.pipeline-runs-segmented__dot--success]="option.dot === 'success'"
                  [class.pipeline-runs-segmented__dot--failure]="option.dot === 'failure'"
                  [class.pipeline-runs-segmented__dot--progress]="option.dot === 'in_progress'"
                  aria-hidden="true"></span>
              }
              <span class="pipeline-runs-segmented__label">{{ option.label }}</span>
              <span class="pipeline-runs-segmented__count">{{ statusOptionCount(option.value) }}</span>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>

      <div class="pipeline-runs-filters__group">
        <span class="pipeline-runs-filters__legend" id="pipeline-runs-type-legend">Tipo</span>
        <mat-button-toggle-group
          class="pipeline-runs-segmented"
          [value]="typeFilter()"
          (change)="onTypeFilterChange($event.value)"
          name="pipeline-runs-type"
          aria-labelledby="pipeline-runs-type-legend"
          hideSingleSelectionIndicator>
          @for (option of typeOptions; track option.value) {
            <mat-button-toggle
              [value]="option.value"
              [attr.aria-checked]="typeFilter() === option.value">
              <span class="pipeline-runs-segmented__label">{{ option.label }}</span>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>

      @if (hasActiveFilters()) {
        <button
          type="button"
          mat-button
          class="pipeline-runs-filters__clear"
          (click)="clearFilters()">
          Limpar filtros
        </button>
      }
    </div>
  </section>

  <div class="pipeline-runs-list" [appSkeleton]="isLoading()">
    @if (totalCount() > 0 || runs().length > 0) {
      <mat-accordion class="pipeline-runs-accordion" multi="false">
        @for (run of runs(); track run.id) {
          <mat-expansion-panel
            class="pipeline-run-panel"
            [class.pipeline-run-panel--active]="run.id === selectedRunId()"
            [class.pipeline-run--failed]="run.status === 'failure'"
            [expanded]="isRunOpened(run.id)"
            (opened)="onPanelOpened(run.id)"
            (closed)="onPanelClosed(run.id)">
            <mat-expansion-panel-header
              class="pipeline-run-header"
              (click)="onHeaderClick(run)">
              <div class="pipeline-run-header-content">
                <div class="pipeline-run-description">
                  <span class="pipeline-run-status-icon" [attr.aria-label]="statusLabelMap[run.status]">
                    <icon-induxtry [icon]="{ icon: statusIconMap[run.status] }"></icon-induxtry>
                  </span>
                  <div class="pipeline-run-title-block">
                    <span class="pipeline-run-title">{{ run.runNumber }} • {{ run.description }}</span>
                    @if (run.automated) {
                      <span
                        class="pipeline-run-automated-icon"
                        [attr.aria-label]="automatedExecutionLabel"
                        [attr.title]="automatedExecutionLabel">
                        <icon-induxtry [icon]="{ icon: 'autoIcon', width: '20px', height: '20px', fill: '#1C2633' }"></icon-induxtry>
                      </span>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel-header>
            <div class="pipeline-run-body">
              <app-pipeline-layers-console
                [layers]="run.layers ?? []"
                [jobId]="run.id"
                [isLoading]="layersLoading() && run.id === selectedRunId()"
                [initialSelectedLayerId]="isRunOpened(run.id) ? initialSelectedLayerId() : null">
              </app-pipeline-layers-console>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>

      @if (totalCount() > 0) {
        <app-page-select
          class="pipeline-runs-paginator"
          [length]="totalCount()"
          [pageSize]="pageSize()"
          [pageSizeOptions]="pageSizeOptions"
          [selectedPage]="page()"
          [removeBackground]="true"
          (emitPageSelected)="onPageSelected($event)"
          (itensOutput)="onPageSizeChange($event)">
        </app-page-select>
      }
    } @else if (!isLoading()) {
      <div class="pipeline-runs-empty">
        @if (hasActiveFilters()) {
          <empty-state
            icon="empty-search"
            title="Nenhuma execução com esses filtros"
            description=""
            [condensed]="true">
          </empty-state>
          <button
            type="button"
            mat-button
            class="pipeline-runs-filters__clear"
            (click)="clearFilters()">
            Limpar filtros
          </button>
        } @else {
          <empty-state
            icon="empty-table"
            title="Nenhuma execução encontrada para esta série."
            description=""
            [condensed]="true">
          </empty-state>
        }
      </div>
    }
  </div>
</div>
